import ActionsForm from '@/shared/mixins/actionsForm'
import colapse from '../occurrenceMaintenance/components/colapse/colapse.vue'
import filterMunutencao from '../occurrenceMaintenance/components/filter/filter.vue'

export default {
  name: 'registerbasicQmaPIVS',
  components: {colapse, filterMunutencao},
  mixins: [ActionsForm],
  data () {
    return {
      details: false
    }
  },
  methods: {
    search (data) {
      this.$refs.collap.formSearch = data
      this.$refs.collap.chamarTable()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/occurrenceMaintenance/occurrenceMaintenance.js